import { render, staticRenderFns } from "./HouseTypeInfo.vue?vue&type=template&id=4c78102a&scoped=true&"
import script from "./HouseTypeInfo.vue?vue&type=script&lang=js&"
export * from "./HouseTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c78102a",
  null
  
)

export default component.exports